import { render, staticRenderFns } from "./myPendingIndex.vue?vue&type=template&id=03c1721e&scoped=true&"
import script from "./myPendingIndex.vue?vue&type=script&lang=js&"
export * from "./myPendingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c1721e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c1721e')) {
      api.createRecord('03c1721e', component.options)
    } else {
      api.reload('03c1721e', component.options)
    }
    module.hot.accept("./myPendingIndex.vue?vue&type=template&id=03c1721e&scoped=true&", function () {
      api.rerender('03c1721e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flow/myPendingIndex.vue"
export default component.exports